import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { kRouteSegments } from '@/routing/paths'

/**
 * Redirects any /chat/:chatFeature URL that isn't /chat/assistant to /chat/assistant.
 *
 * Handles both URL patterns:
 *   - Matter-first: /dashboard/m/:matterId/chat/drafting/... → /dashboard/m/:matterId/chat/assistant/...
 *   - Legacy: /dashboard/chat/drafting/... → /dashboard/chat/assistant/...
 */
export function redirectAliasedChatFeatureRoute({ params, request }: LoaderFunctionArgs): Response | null {
  const originalFeature = params.chatFeature

  // Already the correct feature, do nothing
  if (originalFeature === kRouteSegments.assistant) return null

  // Absolute URL path
  const path = new URL(request.url).pathname

  // Simply replace the feature segment in the path
  const newPath = path.replace(`/chat/${originalFeature}`, `/chat/${kRouteSegments.assistant}`)

  return redirect(newPath)
}
